import React from 'react';
import { Icon } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var IconBlurb = function IconBlurb(_ref) {
  var iconName = _ref.iconName,
      iconType = _ref.iconType,
      _ref$iconClasses = _ref.iconClasses,
      iconClasses = _ref$iconClasses === void 0 ? 'text-lg text-neutral-500 mr-4' : _ref$iconClasses,
      title = _ref.title,
      _ref$titleClasses = _ref.titleClasses,
      titleClasses = _ref$titleClasses === void 0 ? 'font-normal text-neutral-400 text-sm' : _ref$titleClasses,
      description = _ref.description,
      _ref$descriptionClass = _ref.descriptionClasses,
      descriptionClasses = _ref$descriptionClass === void 0 ? 'font-normal text-base' : _ref$descriptionClass;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex my-6 items-start",
    children: [/*#__PURE__*/_jsx("div", {
      className: "w-9 mt-5",
      children: /*#__PURE__*/_jsx(Icon, {
        name: iconName,
        type: iconType,
        className: iconClasses
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col",
      children: [/*#__PURE__*/_jsx("span", {
        className: titleClasses,
        children: title
      }), /*#__PURE__*/_jsx("span", {
        className: "".concat(descriptionClasses, " mt-0.5 break-long-words"),
        children: description
      })]
    })]
  });
};